import axios from 'axios';
import type { RouteRecordNormalized } from 'vue-router';
import { UserState } from '@/store/modules/user/types';
import http from "@/api/interceptor"

export interface LoginData {
  username: string;
  password: string;
}

export interface LoginRes {
  token: string;
}

export function logout() {
  return http.post('/api/logout');
}

export function getUserInfo() {
  return axios.post<UserState>('/api/user/info');
}

export function getMenuList() {
  return axios.post<RouteRecordNormalized[]>('/api/user/menu');
}

// 登录
export function login(data: LoginData) {
  return http.post('/api/login', data);
}

// 数据统计
export function getStatistic() {
  return http.get('/api/statistic');
}

// 订单列表
export function getOrders(params: object) {
  return http.get('/api/orders', { params });
}

// 异常订单列表
export function getExceptionOrders(params: object) {
  return http.get('/api/orders/exceptions', { params });
}

// 订单详情
export function getOneOrder(id?: number) {
  return http.get(`/api/orders/${id}`);
}

// 订单详情产品
export function getOneOrderProducts(id: number, params: object) {
  return http.get(`/api/orders/${id}/products`, { params });
}

// 订单详情产品-送评结果
export function getResults(id: number) {
  return http.get(`/api/orders/${id}/grading_result`)
}

// 订单签收
export function receiveOrder(id: number) {
  return http.post(`/api/orders/${id}/received`)
}

// 查验入库
export function auditOrderFun(id: number, params: object) {
  return http.post(`/api/orders/${id}/audit`, params)
}

// 查验入库确认
export function auditConfirmFun(id: number) {
  return http.post(`/api/orders/${id}/audit_confirm`)
}

// 更新国际物流
export function intl_ship(id: number) {
  return http.post(`/api/orders/${id}/intl_ship`)
}
// 批量更新国际物流
export function batch_intl_ship(params: object) {
  return http.post("/api/orders/order_batch_intl_ship", params)
}

// 批量导入评分结果
export function importResult(data: object) {
  return http.post("/api/orders/grading_result", data)
}

// 寄回订单列表
export function getReturnOrders(params: object) {
  return http.get("/api/return_orders", { params })
}

// 填写寄回订单物流
export function writeShip(id: number, params: object) {
  return http.post(`/api/return_orders/${id}/ship`, params)
}

// 寄回订单详情
export function getOrderDetail(id: number) {
  return http.get(`/api/return_orders/${id}`)
}

// 寄回订单产品列表
export function getOrderProducts(id: number, params: object) {
  return http.get(`/api/return_orders/${id}/products`, { params })
}

// 批量回国入库
export function productReturn(params: object) {
  return http.post("/api/orders/intl_product_return", params)
}

// 送评类型
export function getTypesData() {
  return http.get("/api/types")
}

// 创建寄回订单
export function createOrder(id: number) {
  return http.post(`/api/orders/${id}/create_return_order`)
}

// 上传视频token
export function uploadToken() {
  return http.get("/api/upload_token")
}

// 送评订单更新
export function updateOrderFun(id: number, params: object) {
  return http.post(`/api/orders/${id}`, params)
}

// 订单导出
export function exportOrdersFun(params: object) {
  return http.get("/api/orders/export", { params })
}

// 当前账户信息
export function getCompany() {
  return http.get("/api/session")
}

// 数据报表
export function getReport(params: object) {
  return http.get("/api/orders/report", { params })
}
